import { CallbackLogsComponent } from '../../nexsys-monitor/callback-logs/callback-logs.component';
import { NexsysLogsOrderComponent } from '../../nexsys-monitor/nexsys-logs-order/nexsys-logs-order.component';
import { NexsysMonitorHeaderComponent } from '../../nexsys-monitor/nexsys-monitor-header/nexsys-monitor-header.component';
import { NexsysOrdersComponent } from '../../nexsys-monitor/nexsys-orders/nexsys-orders.component';
import { NotAllowedComponent } from '../../not-allowed/not-allowed.component';
import { OrdersPartialLogComponent } from '../../partialIntegration/components/orders-partial-log/orders-partial-log.component';
import { PartialHeaderComponent } from '../../partialIntegration/components/partial-header/partial-header.component';
import { PartialIntegrationComponent } from '../../partialIntegration/partial-integration.component';
import { ProductsLoaderService } from '../../products/service/products-loader.service';

export const NOT_ALLOWED = [
	{
		path: 'not-allowed',
		component: NotAllowedComponent,
	},
];

export const NEXSYS_MONITOR = [
	{
		path: 'nexsys-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'nexsys-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const VALUTRUST_MONITOR = [
	{
		path: 'valutrust-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'valutrust-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const XPANSE_MONITOR = [
	{
		path: 'xpanse-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'xpanse-monitor/order-log/:transactionId/:SPNId',
		component: NexsysLogsOrderComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const FNC_MONITOR = [
	{
		path: 'fnc-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'fnc-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const ORDERS_MONITOR = [
	{
		path: 'orders-monitor/orders',
		component: NexsysOrdersComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		},
		canActivate: [ProductsLoaderService]
	}
];

export const NEXSYS_ORPHAN_MONITOR = [
	{
		path: 'nexsys-legacy-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const ORDERS_EXTERNAL_MONITOR = [
	{
		path: 'order-external-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'order-external-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const EVO_MONITOR = [
	{
		path: 'evo-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'evo-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const BASE_MONITOR = [
	{
		path: 'nexsys-monitor',
		redirectTo: 'nexsys-monitor/logs',
		pathMatch: 'prefix'
	}
];

export const VALUELINK_MONITOR = [
	{
		path: 'valuelink-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			subComponentShow: true,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'valuelink-monitor/order-log/:id/:providerClientId',
		component: NexsysLogsOrderComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const VALUELINK_LENDER_MONITOR = [
	{
		path: 'valuelink-lender-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			subComponentShow: true,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'valuelink-lender-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const CONNEXIONS_MONITOR = [
	{
		path: 'connexions-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			subComponentShow: true,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'connexions-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const LENDING_QB_MONITOR = [
	{
		path: 'lending-qb-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			subComponentShow: true,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'lending-qb-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const LANDGORILLA_MONITOR = [
	{
		path: 'landgorilla-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			subComponentShow: true,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'landgorilla-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const FICS_MONITOR = [
	{
		path: 'fics-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			subComponentShow: true,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'fics-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

export const LENDINGPAD_MONITOR = [
	{
		path: 'lendingpad-monitor/logs',
		component: CallbackLogsComponent,
		data: {
			subComponentShow: true,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	},
	{
		path: 'lendingpad-monitor/order-log/:id',
		component: NexsysLogsOrderComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: NexsysMonitorHeaderComponent
		}
	}
];

// PARTIAL INTEGRATIONS
export const MI_MUTUAL_MONITOR = [
	{
		path: 'mi-mutual/orders',
		component: PartialIntegrationComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: PartialHeaderComponent
		}
	},{
		path: 'mi-mutual/logs/:id',
		component: OrdersPartialLogComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: PartialHeaderComponent
		}
	}
];

export const RELIANCE_FIRST_MONITOR = [
	{
		path: 'reliance-first/orders',
		component: PartialIntegrationComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: PartialHeaderComponent
		}
	},
	{
		path: 'reliance-first/logs/:id',
		component: OrdersPartialLogComponent,
		data: {
			subComponentShow: false,
			breadcrumbComponent: PartialHeaderComponent
		}
	}
];
